import { render, staticRenderFns } from "./TermsDetailLink.vue?vue&type=template&id=21687f76&scoped=true&"
import script from "./TermsDetailLink.vue?vue&type=script&lang=js&"
export * from "./TermsDetailLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21687f76",
  null
  
)

export default component.exports